import { GraphqlQueryResponse } from "@/Common/api/types/GraphqlQueryResponse";
import { errorLogger } from "@/Common/helpers/logger";
import { apiInstance, gql } from "@/services/httpAdapter";

// Types
import { IPayrollProviderCustomFieldOption, IMappedCustomField } from "@/Settings/types/PayrollMapping/CustomFieldItemsMapping/api";
import { IMappedPayItem, IPayrollProviderPayItemOption } from "@/Settings/types/PayrollMapping/api";

export async function getPayItemOptionsByLocationId(locationId: string) {
	const query = gql`
		query getPayItemOptionsByLocationId($locationId: String!) {
			getPayItemOptionsByLocationId(locationId: $locationId) {
				displayId
				companyId
				updatedAt
				payItems {
					componentId
					name
				}
			}
		}
	`;

	const variables = {
		locationId,
	};

	try {
		const response: GraphqlQueryResponse<"getPayItemOptionsByLocationId", IPayrollProviderPayItemOption[]> = await apiInstance.post(
			"/graphql",
			{
				query,
				variables,
			}
		);
		return response.data?.data?.getPayItemOptionsByLocationId;
	} catch (err) {
		errorLogger(err as Error, { function: "getPayItemOptionsByLocationId", message: "Failed to get pay items options.", variables });
		return null;
	}
}
export async function getMappedPayItems(locationId: string) {
	const query = gql`
		query getMappedPayItems($locationId: String!) {
			getMappedPayItems(locationId: $locationId) {
				locationId
				mappedPayItems {
					_id
					systemPayItem
					payrollPayItems {
						displayId
						companyId
						componentId
						name
					}
					type
					hoursMemo
				}
			}
		}
	`;
	const variables = {
		locationId,
	};

	try {
		const response: GraphqlQueryResponse<"getMappedPayItems", IMappedPayItem> = await apiInstance.post("/graphql", {
			query,
			variables,
		});
		return response.data?.data?.getMappedPayItems ?? null;
	} catch (err) {
		errorLogger(err as Error, {
			function: "getMappedPayItems",
			message: "Failed to get mapped pay items.",
			variables,
		});
		return null;
	}
}

export async function getCustomFieldDefinitionsByLocationId(locationId: string) {
	const query = gql`
		query getCustomFieldDefinitionsByLocationId($locationId: String!) {
			getCustomFieldDefinitionsByLocationId(locationId: $locationId) {
				displayId
				companyId
				customFields {
					fieldName
					fieldId
				}
			}
		}
	`;
	const variables = {
		locationId,
	};

	try {
		const response: GraphqlQueryResponse<"getCustomFieldDefinitionsByLocationId", IPayrollProviderCustomFieldOption[]> =
			await apiInstance.post("/graphql", {
				query,
				variables,
			});
		return response.data?.data?.getCustomFieldDefinitionsByLocationId;
	} catch (err) {
		errorLogger(err as Error, {
			function: "getCustomFieldItemsByLocationId",
			message: "Failed to get custom field items by location.",
			variables,
		});
		return [];
	}
}

export async function getMappedCustomFields(locationId: string) {
	const query = gql`
		query getMappedCustomFields($locationId: String!) {
			getMappedCustomFields(locationId: $locationId) {
				locationId
				mappedCustomFields {
					_id
					systemCustomField
					payrollCustomFields {
						displayId
						companyId
						fieldId
						fieldName
					}
				}
			}
		}
	`;
	const variables = {
		locationId,
	};

	try {
		const response: GraphqlQueryResponse<"getMappedCustomFields", IMappedCustomField> = await apiInstance.post("/graphql", {
			query,
			variables,
		});
		return response.data?.data?.getMappedCustomFields ?? ({} as unknown as IMappedCustomField);
	} catch (err) {
		errorLogger(err as Error, {
			function: "getMappedCustomFields",
			message: "Failed to get mapped custom fields.",
			variables,
		});
		return {} as unknown as IMappedCustomField;
	}
}
